import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

import Layout from '../views/layout/Layout'


export const constantRouterMap = [
    {path: '/adminlogin', component: () => import('@/views/login/index'), hidden: true},
    {path: '/userlogin', component: () => import('@/views/login/user'), hidden: true},
    {path: '/404', component: () => import('@/views/404'), hidden: true},
    {path: '/register', component: () => import('@/views/register/index'), hidden: true},
    {
        path: '',
        component: Layout,
        redirect: '/dashboard',
        hidden: true,
        icon: 'dashboard',
        name: '首页',
        children: [{
            path: 'dashboard',
            component: (resolve) => require(['../views/dashboard/index'], resolve)
        }]
    }
]


export default new Router({
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
})


// 异步挂载的路由
// 动态需要根据权限加载的路由表
export const asyncRouterMap = [
    {
        path: '',
        component: Layout,
        icon: 'dashboard',
        name: '台账',
        children: [{
            path: 'dashboard',
            name: '统计报表',
            redirect: 'dashboard'
        }]
    },
    {
        path: '/list',
        component: Layout,
        redirect: '/list/admin',
        name: '管理员',
        icon: 'peoples',
        meta: {role: ['admin']},
        children: [
            {
                path: 'adminList',
                name: '管理员列表',
                component: (resolve) => require(['../views/list/admin'], resolve)
            },
            {
                path: 'whiteList',
                name: '企业白名单列表',
                component: (resolve) => require(['../views/list/whiteList'], resolve)
            },
            {
                path: 'amountAdmin',
                name: '用量管理',
                component: (resolve) => require(['../views/list/amountAdmin'], resolve)
            },
            {
                path: 'dictionary',
                name: '字典管理',
                component: (resolve) => require(['../views/list/dictionary'], resolve)
            }
        ]
    },
    {
        path: '/cer',
        component: Layout,
        redirect: '/cer/cachet',
        meta: {role: ['admin']},
        name: '证书',
        icon: 'table',
        children: [

            {
                path: 'cachet',
                name: '机构证书',
                component: (resolve) => require(['../views/cer/cachetCer'], resolve)
            },
            {
                path: 'cer',
                name: '机构列表',
                component: (resolve) => require(['../views/cer/cerList'], resolve)
            },
            {
                path: 'userCachet',
                name: '用户证书',
                component: (resolve) => require(['../views/cer/userCachet'], resolve)
            },

        ]
    },
    {
        path: '/usrFile',
        component: Layout,
        redirect: '/user/file',
        meta: {role: ['user']},
        name: '文件',
        icon: 'nested',
        children: [

            {
                path: 'file',
                name: '提交文件',
                meta: {role: ['user']},
                component: (resolve) => require(['../views/register/userFile'], resolve)
            }

        ]
    },
    {
        path: '/log',
        component: Layout,
        redirect: '/log/adminLog',
        meta: {role: ['admin']},
        name: '日志审计',
        icon: 'list',
        // meta: {role :['6'] },
        children: [

            {
                path: 'adminLog',
                name: '管理员日志',
                component: (resolve) => require(['../views/log/adminLog'], resolve)
            },
            {
                path: 'thrid',
                name: '接口日志',
                component: (resolve) => require(['../views/log/thridLog'], resolve)
            }

        ]
    },

    {path: '*', redirect: '/404', hidden: true}
]



// WEBPACK FOOTER //
// ./src/router/index.js